// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1ghYO","list":"PatternAutocomplete_list__2nPOS"};